import { clsx } from 'clsx';
import { useQueryClient } from 'react-query';

import ClockIcon from '@ping/assets/Icon/clock.svg';
import { t } from '@ping/helpers';
import { activeBusinessReviewNotice } from '@ping/pages/business/verification/active-business-review';
import { ActiveBusinessReviewModal } from '@ping/pages/business/verification/ActiveBusinessReviewModal';
import { kybBusinessStatusQueryKey, useKybBusinessStatus } from '@ping/pages/business/verification/kyb-status.api';
import {
  isBusinessLoginSelector,
  isUserVerifiedSelector,
  useUserInformationStore,
} from '@ping/stores/userInformation.store';
import { Modal } from '@ping/uikit';

import style from './style.module.scss';

export const ActiveBusinessReviewTriggerButton = () => {
  const queryClient = useQueryClient();
  const isBusinessLogin = useUserInformationStore(isBusinessLoginSelector);
  const isVerified = useUserInformationStore(isUserVerifiedSelector);
  const { data: status } = useKybBusinessStatus({ enabled: isBusinessLogin && isVerified });
  const notice = isBusinessLogin && isVerified ? activeBusinessReviewNotice(status) : undefined;

  if (!notice) {
    return null;
  }

  return (
    <Modal.Root>
      <Modal.Context.Consumer>
        {ctx => (
          <>
            <Modal.Trigger
              className={clsx(style['pending-approval--btn'], {
                [style['is-more-data-needed']]: notice === 'more-data',
                [style['is-pending-for-review']]: notice === 'pending',
                [style['is-open']]: notice === 'open',
              })}
            >
              <ClockIcon />
              <span className={style['pending-approval--btn-text']}>
                {notice === 'more-data' && t('Provide more data')}
                {notice === 'open' && t('Review in progress')}
                {notice === 'pending' && t('Pending for review')}
              </span>
            </Modal.Trigger>
            <ActiveBusinessReviewModal
              comment={status?.review?.reviewComment}
              ctx={ctx}
              notice={notice}
              onSubmitted={() => void queryClient.invalidateQueries(kybBusinessStatusQueryKey)}
            />
          </>
        )}
      </Modal.Context.Consumer>
    </Modal.Root>
  );
};
